import { Question } from '../../../types';
import { TagsField } from '../../components';

interface DateQuestionConfigProps {
  question: Question;
  onEdit: (questionId: string, updates: Partial<Question>) => void;
}

export function DateQuestionConfig({
  question,
  onEdit,
}: DateQuestionConfigProps) {
  return (
    <div className="space-y-2">
      <TagsField
        value={question.tags || []}
        onChange={(tags) => onEdit(question.id, { tags })}
      />
    </div>
  );
}
